export default __webpack_public_path__ + "static/media/cre.c25e722a.svg";